import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { useState, useMemo } from "react";
import AdminTable from "../Administrator/Helpers/AdminTable";
import { getTransactions } from "src/store/Slices/ClientsSlice";
import EditTransactions from "./Modals/EditTransactions";
import dayjs from "dayjs";
const ClientsTransactions = ({
  clientInfo,
  title,
  page,
  pageSize,
  setPage,
  setPageSize,
  mnemo,
  transactionsInfo,
  setTransactionsInfo,
  payload,
}) => {
  const dispatch = useDispatch();
  console.log(mnemo.children);
  const items = [
    {
      key: "1",
      label: "Возврат",
      onClick: () => {
        setIsOpenEditModal(true);
      },
      disabled: !mnemo?.children
        ?.find((el) => el.name === "Таблица транзакций")
        ?.children.find((ele) => ele.mnemo === "refundBtn"),
    },
  ];
  const [isOpenEditModal, setIsOpenEditModal] = useState(false);

  // STORE
  const transactionsList = useSelector(
    (state) => state.ClientsSlice.getClientTransactionsList
  );
  const transactionsListLoading = useSelector(
    (state) => state.ClientsSlice.getClientTransactionsListLoading
  );

  const searchItemsMap = (keys, values) => {
    const formattedItems = {};
    if (keys && values) {
      keys.forEach((key, index) => {
        console.log(key, index);
        if (values[index] != undefined && values[index][0] != undefined) {
          if (key === "startDate") {
            formattedItems["StartDate.From"] = dayjs(values[index][0]).format(
              "YYYY-MM-DD"
            );
            formattedItems["StartDate.To"] = dayjs(values[index][1]).format(
              "YYYY-MM-DD"
            );
          } else if (key === "endDate") {
            formattedItems["EndDate.From"] = values[index][0];
            formattedItems["EndDate.To"] = values[index][1];
          } else if (key === "transactionDate") {
            formattedItems["TransactionDate.From"] = dayjs(
              values[index][0]
            ).format("YYYY-MM-DD");
            formattedItems["TransactionDate.To"] = dayjs(
              values[index][1]
            ).format("YYYY-MM-DD");
          } else {
            formattedItems[key] = values[index][0];
          }
        }
      });
      return formattedItems;
    }
  };
  const handleTableChange = (pagination, filters, sorter) => {
    const payload = searchItemsMap(
      Object.keys(filters),
      Object.values(filters)
    );
    dispatch(
      getTransactions({
        UserId: clientInfo.id,
        count: pagination.pageSize,
        offset: pagination.pageSize * (pagination.current - 1),
        orderBy: sorter?.column?.dataIndex,
        isDesc: sorter.order
          ? sorter.order === "ascend"
            ? true
            : false
          : undefined,
        ...payload,
      })
    );
    setPage(pagination.current);
    setPageSize(pagination.pageSize);
  };

  const onClickRowOne = (record) => {
    setTransactionsInfo(record);
  };

  const formatedTransactionsRows = useMemo(() => {
    return transactionsList?.data?.value?.rows?.map((element) => ({
      ...element,
      startDate: element.startDate
        ? dayjs(element?.startDate).format("DD.MM.YYYY HH:mm:ss")
        : "",
      endDate: element.endDate
        ? dayjs(element?.endDate).format("DD.MM.YYYY HH:mm:ss")
        : "",
      transactionDate: element.transactionDate
        ? dayjs(element?.transactionDate).format("DD.MM.YYYY HH:mm:ss")
        : "",
    }));
  }, [transactionsList]);

  return (
    <>
      <EditTransactions
        transactionsModal={isOpenEditModal}
        setTransactionsModal={setIsOpenEditModal}
        clientInfo={clientInfo}
        transactionsInfo={transactionsInfo}
        payload={payload}
      />
      {window.innerWidth >= 768 && (
        <AdminTable
          scroll={{ x: 0, y: 200 }}
          page={page}
          setPage={setPage}
          pageSize={pageSize}
          setPageSize={setPageSize}
          onChange={handleTableChange}
          loading={transactionsListLoading}
          onClickRowOne={onClickRowOne}
          columns={transactionsList}
          rows={formatedTransactionsRows}
          total={transactionsList?.data?.value?.totalCount}
          title={title}
          items={items}
        />
      )}
    </>
  );
};

export default ClientsTransactions;
